import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const OOPS_M1_ParseTreeAndAmbiguity = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Parse Tree and Elimination of Ambiguity"
    videos={[
      "https://www.youtube.com/embed/SBMIcei8oyg",
      "https://www.youtube.com/embed/X-7gPMZywSQ",
      "https://www.youtube.com/embed/gJP46039g5A",
    ]}
    takeaways={[
      { text: "Learn the dangling else problem from this topic" },
      { text: "Learn how to remove left recursion and left factoring from this topic" },
    ]}
    questions={[
      `a) Check whether the following grammar is ambiguous or not. If it's 
ambiguous remove the ambiguity from it. And cross check the string 
"if con then if con then other else other" is derivable through only one 
parse tree from your unambiguous grammar.

stmt >if con then stmt | if con then stmt else stmt | other`,
      `Consider a Grammar G=(V, T, P, S) where P: S->aSbS|bSaS|ε and w=abab. Is the grammar ambiguous or not? Justify your answers with an explanation.`,
    ]}
    exampleVideos={[]}
  />
);
}

export default OOPS_M1_ParseTreeAndAmbiguity;
